import { playNotificationSound } from "./helper/notificationSound";
import { getFresherPerferenceLists } from "./services/Notification";

export const useUserNotificationSubscribeHook = () => {
  async function regSw() {
    if ("serviceWorker" in navigator) {
      try {
        const reg = await navigator.serviceWorker.register("/sw.js", {
          scope: "/",
        });
        // console.log('ServiceWorker registration successful', reg);

        // Check if service worker is controlling the page
        if (navigator.serviceWorker.controller) {
          //   console.log("Service worker is controlling the page");
        } else {
          //   console.log("Service worker not controlling the page - reloading");
          window.location.reload();
        }

        return reg;
      } catch (error) {
        console.error("ServiceWorker registration failed:", error);
        throw error;
      }
    }
    throw Error("serviceWorker not supported");
  }

  async function subscribe(serviceWorkerReg, notificationData) {
    try {
      let subscription = await serviceWorkerReg.pushManager.getSubscription();
      if (subscription === null) {
        subscription = await serviceWorkerReg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey:
            "BJ9OXOUjV3lfJzNC8cjgHNRqxXdNBObYBXTjCWfRmvnlyx90EDWO6lpC1fteYbFZLMe_I8M2yFQ_EqbRiovwOvU",
        });
        const payload = {
          subscription: JSON.stringify(subscription),
          userId: notificationData.userId,
          type: notificationData.type,
        };
        const { data } = await getFresherPerferenceLists(payload);
      }
    } catch (error) {
      //   console.log("Error subscribing to push notifications:", error);
    }
  }

  async function registerAndSubscribe(data) {
    try {
      const serviceWorkerReg = await regSw();
      await subscribe(serviceWorkerReg, data);
    } catch (error) {
      return error;
    }
  }

  return { regSw, subscribe, registerAndSubscribe };
};
